import { ResponsivePie } from '@nivo/pie';

function PieChart(props) {
	return (
		<ResponsivePie
			data={props.data || []}
			margin={{ top: 15, right: 15, bottom: 15, left: 15 }}
			innerRadius={0.6}
			activeOuterRadiusOffset={10}
			borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
			arcLinkLabelsSkipAngle={10}
			arcLinkLabelsTextColor={{ from: 'color', modifiers: [] }}
			arcLinkLabelsThickness={2}
			arcLinkLabelsColor={{ from: 'color', modifiers: [] }}
			enableArcLabels={true}
			arcLabelsSkipAngle={10}
			enableArcLinkLabels={false}
			arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
			defs={[
				{
					id: 'dots',
					type: 'patternDots',
					background: 'inherit',
					color: 'rgba(255, 255, 255, 0.3)',
					size: 4,
					padding: 1,
					stagger: true,
				},
				{
					id: 'lines',
					type: 'patternLines',
					background: 'inherit',
					color: 'rgba(255, 255, 255, 0.3)',
					rotation: -45,
					lineWidth: 6,
					spacing: 10,
				},
			]}
			fill={[]}
			colors={props.color}
			legends={[]}
			tooltip={(point) => {
				return <div></div>;
			}}
			onMouseMove={(data) => {
				props.onMouseMove(data.label);
			}}
			onMouseLeave={() => props.onMouseMove()}
			onClick={(point) => {
				if (props.onClick) props.onClick(point);
			}}
		/>
	);
}

export default PieChart;
